// src/components/DatasetDetail.jsx
import React, { useState } from 'react';
import { useParams, Link, useLocation } from 'react-router-dom';
import RunEvalModal from '../Evaluation/RunEvalModal';

export default function DatasetDetail() {
  const { datasetId } = useParams();
  const location = useLocation();
  const [showRunEvalModal, setShowRunEvalModal] = useState(false);
  const iframeSrc = `https://huggingface.co/datasets/Knowtex-ai/${datasetId}/embed/viewer/default/train`;

  // Callers set `location.state.from` so the back link returns to the right
  // page. Fall back to inferring from the dataset name's `{lambda}__` prefix
  // (eval datasets) and otherwise to /fine-tuning.
  const fallbackFrom = typeof datasetId === 'string' && datasetId.includes('__')
    ? '/evaluation'
    : '/fine-tuning';
  const backTo = location.state?.from || fallbackFrom;
  const backLabel = backTo === '/evaluation' ? '← Back to evaluation' : '← Back to datasets';

  // Run-eval is wired only for RunChatGPTSummarizeFunction datasets in v1.
  const canRunEval =
    typeof datasetId === 'string' &&
    datasetId.startsWith('RunChatGPTSummarizeFunction__');

  return (
    <div className="w-full mx-auto p-6 space-y-6">
      <Link to={backTo} className="text-sm text-gray-500 hover:underline">
        {backLabel}
      </Link>

      <div className="flex items-center justify-between gap-4">
        <h1 className="text-2xl font-bold">Dataset Viewer: {datasetId}</h1>
        {canRunEval && (
          <button
            type="button"
            onClick={() => setShowRunEvalModal(true)}
            className="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-ktx-purple hover:bg-ktx-purple-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-ktx-purple"
          >
            Run Eval
          </button>
        )}
      </div>

      <div className="bg-white rounded-xl shadow-lg border border-gray-200 overflow-hidden">
        <div className="relative w-full pt-[45%]">
          <iframe
            src={iframeSrc}
            frameBorder="0"
            allowFullScreen
            className="absolute top-0 left-0 w-full h-full"
            title={`HuggingFace Dataset Viewer: ${datasetId}`}
          />
        </div>
      </div>

      {showRunEvalModal && (
        <RunEvalModal
          datasetName={datasetId}
          closeModal={() => setShowRunEvalModal(false)}
        />
      )}
    </div>
  );
}
